module.exports = "<md-button aria-label=Importar class=\"md-fab md-raised md-mini\" ng-click=$ctrl.showModal($event)> <md-tooltip>Importar CSV</md-tooltip> <md-icon aria-label=Importar class=material-icons>fingerprint</md-icon> </md-button> ";


//////////////////
// WEBPACK FOOTER
// ./src/components/tsz-import-csv/tsz-import-csv.html
// module id = 134
// module chunks = 1